export default __webpack_public_path__ + "static/Mr. Sami Faisal-a58868388c1ab8f1d094e01bfbc6b476.jpeg";